export const BASE_URL = process.env.REACT_APP_HOME_URL || "//lpga.gnsson.com";

export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
